<template>
	<v-sheet rounded class="mb-4">
		<v-card color="#125B92" elevation="0" class="rounded-b-0">
			<v-card-title>
				<v-icon left large color="#E3ECF2">mdi-folder-check</v-icon>
				<h3 class="white--text">Edit Project</h3>
			</v-card-title>
			<v-divider />
			<v-card-text class="pt-7">
				<project-form :project="project" />
			</v-card-text>
		</v-card>
	</v-sheet>
</template>
<script>
import ProjectForm from '@/Pages/Backend/Projects/Form'

export default {
	components: { ProjectForm },
	props: {
		project: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
